import { StatisticsList } from "Components/StatisticsList";

const StatisticsPage = () => <StatisticsList />;

export default StatisticsPage;
